import React from 'react';

const Footer: React.FC = () => {
  const footerLinks: string[] = [
    'About Velora',
    'Documentation', 
    'Terms of Service',
    'Privacy Policy'
  ];

  return (
    <div className="absolute left-4 md:left-8 bottom-4 md:bottom-8 right-4 md:right-8 flex flex-col md:flex-row justify-between items-center gap-4 md:gap-0">
      <div className="text-[#908e97] text-xs font-geist">
        Velora ©
      </div>
      
      <div className="flex flex-wrap justify-center md:justify-start gap-4 md:gap-6">
        {footerLinks.map((link, index) => (
          <button 
            key={index}
            onClick={() => {
              if (link === 'About Velora') {
                window.open('https://velora.xyz', '_blank');
              } else if (link === 'Documentation') {
                window.open('https://www.velora.xyz/docs', '_blank');
              } else if (link === 'Terms of Service') {
                window.open('https://velora.xyz/tos', '_blank');
              } else if (link === 'Privacy Policy') {
                window.open('https://velora.xyz/pp', '_blank');
              } else {
                console.log(`Clicked ${link}`);
              }
            }}
            className="text-[#908e97] text-xs font-geist hover:text-primary-azul transition-colors cursor-pointer"
          >
            {link}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Footer;
